import { observer } from "mobx-react-lite";
import QRCodeStyling, { Options } from "qr-code-styling";
import React, { useEffect, useRef } from "react";
import { getRemoteJson } from "../../app/helpers/jsonHelpers";

interface IParams {
  remoteOptionsUrl?: string;
  qrStyleOptions?: Partial<Options>;
  data: string;
  size?: number;
}

const QRCodeComponent: React.FC<IParams> = ({
  remoteOptionsUrl,
  qrStyleOptions,
  data,
  size,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const defaultQROptions: Partial<Options> = {
    height: 200,
    width: 200,
    imageOptions: { crossOrigin: "anonymous" },
  };

  const getQRCodeStyling = async () => {
    let options: Partial<Options> = defaultQROptions;
    let styling: QRCodeStyling;

    if (qrStyleOptions) options = qrStyleOptions;
    else if (remoteOptionsUrl) {
      const json = await getRemoteJson(remoteOptionsUrl);
      if (json) options = json;
    }

    //override IParams
    if (data) options.data = data;
    if (size) {
      options.height = size;
      options.width = size;
    }

    styling = new QRCodeStyling(options);
    return styling;
  };

  useEffect(() => {
    getQRCodeStyling()
      .then((styling) => {
        if (ref.current) {
          ref.current.innerHTML = "";
          styling.append(ref.current);
        }
      })
      .catch();
  }, []);

  return (
    <>
      <div ref={ref}></div>
    </>
  );
};

export default observer(QRCodeComponent);
